import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { MailboxInfo } from 'owa-client-types';

const successfullyLoadedAccounts = new Set<string>();

export function isOptionsLoadedForAccount(mailboxInfo: MailboxInfo): boolean {
    return successfullyLoadedAccounts.has(getAccountKeyForMailboxInfo(mailboxInfo));
}

export function clearOptionsLoadedAccounts(): void {
    successfullyLoadedAccounts.clear();
}

export function markOptionsLoadedForAccount(mailboxInfo: MailboxInfo): void {
    successfullyLoadedAccounts.add(getAccountKeyForMailboxInfo(mailboxInfo));
}
